import React from 'react';
import Text, { FontFamilyVariant, TextType } from '@components/Text';

import "./styles.less";

interface IProps {
    id: number;
    icon: string;
    title: string;
    description: string;
}

const FeatureCard = (props: IProps) => {
    const { id, icon, title, description } = props;
    return (
        <div className="feature-card-container" key={id}>
            <img alt ={"icon"} src={icon} />
            <div className="feature-title-container">
                <Text
                    className="feature-title"
                    fontFamilyVariant={FontFamilyVariant.bold1}
                    text={title}
                    textType={TextType.display2}
                />
            </div>
            <div>
                <Text
                    fontFamilyVariant={FontFamilyVariant.medium}
                    text={description}
                    textType={TextType.h8}
                />
            </div>

        </div>
    )
}

export default FeatureCard;
